import { render, staticRenderFns } from "./IndemnityAnnotations.vue?vue&type=template&id=20e17d0d&scoped=true"
import script from "./IndemnityAnnotations.vue?vue&type=script&lang=js"
export * from "./IndemnityAnnotations.vue?vue&type=script&lang=js"
import style0 from "./IndemnityAnnotations.vue?vue&type=style&index=0&id=20e17d0d&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e17d0d",
  null
  
)

export default component.exports